import React, { forwardRef } from "react";
import { Image } from "react-bootstrap";

import "./PlayerMatchingCard.scss";
import PersonIcon from "../../icons/PersonIcon";
import LoadingDots from "../../LoadingDots/LoadingDots";
import { useTranslation } from "react-i18next";

interface PlayerMatchingCardProps {
  isOpponent?: boolean;
  isSearching?: boolean;
  avatar?: string;
  username?: string;
}

const PlayerMatchingCard = forwardRef<HTMLDivElement, PlayerMatchingCardProps>(
  ({ isOpponent, isSearching, avatar, username }, ref) => {
    const { t } = useTranslation("games");
    const usernameText = isSearching ? t("searching") : username;
    let cardBg;
    let avatarBg;
    let textColor;
    if (isSearching) {
      cardBg = "#2B1D4C";
      avatarBg = "#F3CC57";
    } else if (isOpponent) {
      cardBg = "#F0FFFF";
      avatarBg = "#131313";
      textColor = "#000000";
    }

    return (
      <div
        className="matching-card d-flex justify-content-center align-items-center flex-column"
        style={{ background: cardBg }}
        ref={ref}
      >
        <p
          className="avatar-box d-flex justify-content-center align-items-center"
          style={{ background: avatarBg }}
        >
          {avatar && !isSearching ? (
            <Image src={avatar} alt="" />
          ) : (
            <PersonIcon fill="#29292D" height={25} width={25} />
          )}
        </p>
        <div
          className="username d-flex align-items-end"
          style={{ color: textColor }}
        >
          <p>
            {!isSearching && usernameText && "@"}
            {usernameText}
          </p>{" "}
          {isSearching && (
            <LoadingDots
              dotStyles={{ background: "white", height: 1, width: 1 }}
              containerStyles={{ marginBottom: 2 }}
            />
          )}
        </div>
      </div>
    );
  }
);

export default PlayerMatchingCard;
